import {
  useGetConferenceQuery,
  useGetConferenceIncludingHiddenQuery,
} from "../store/conference/conference";
import { Conference } from "../types/conference.types";

interface UseConferenceQueryResult {
  congressEvent: Conference | null;
  isLoadingCongressEvent: boolean;
  isError: boolean;
}

export const useConferenceQuery = (
  congressId: number,
  isEditMode: boolean
): UseConferenceQueryResult => {
  const publicConferenceQuery = useGetConferenceQuery(congressId, {
    skip: isEditMode,
  });
  const hiddenConferenceQuery = useGetConferenceIncludingHiddenQuery(
    congressId,
    {
      skip: !isEditMode,
    }
  );

  const congressEvent = isEditMode
    ? hiddenConferenceQuery.data ?? null
    : publicConferenceQuery.data ?? null;
  const isLoadingCongressEvent = isEditMode
    ? hiddenConferenceQuery.isLoading
    : publicConferenceQuery.isLoading;
  const isError = isEditMode
    ? hiddenConferenceQuery.isError
    : publicConferenceQuery.isError;

  return { congressEvent, isLoadingCongressEvent, isError };
};
